import { getNestedValue } from "../../../../../utils/function";

const AutoCell = (props) => {
  const accessor = props.column.id;
  const data = getNestedValue(props.row.original, accessor, "-");

  return (
    <div className="shrink" title={data}>
      {data}
    </div>
  );
};

export default AutoCell;
